import script from "./searchOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./searchOrder.vue?vue&type=script&setup=true&lang=js"

import "./searchOrder.vue?vue&type=style&index=0&id=af72d602&lang=scss"

const __exports__ = script;

export default __exports__